import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import EmployeeFlowLayout from 'components/common/subscriber/EmployeeFlowLayout';
import NavigationActionFooter from 'components/common/general/NavigationActionFooter';
import { SubscriberRouteV2Id } from 'routes/routesConfigV2';
import { useMedicalCategoryPageStore } from 'store/pages/subscriber/imq/medical-category/pageStore';
import { MedicalCategoryName } from 'components/common/subscriber/imq/medical-category/MedicalCategoryName';
import { MedicalCategoryProgress } from 'components/common/subscriber/imq/medical-category/MedicalCategoryProgress';
import { DynamicForm } from '@insurancemenu/imenu-components-lib';

const PageContent: React.FC = observer(() => {
  const {
    getInitialData,
    isInitialLoading,
    isFormValid,
    isActionLoading,
    flowDelegate,
    categoryName,
    subscriberImqModule,
    dynamicFormDelegate,
    nextCategoryName,
    returnBack,
    saveAndReturnToList,
    saveAndGoToNextForm,
  } = useMedicalCategoryPageStore();

  useEffect(() => {
    void getInitialData();
  }, [categoryName, getInitialData]);

  return (
    <EmployeeFlowLayout
      contentWidth="standard"
      flowDelegate={flowDelegate}
      pageId={SubscriberRouteV2Id.SUBSCRIBER_HEALTH_QUESTIONNAIRE_MEDICAL_CATEGORY}
      isInitialLoading={isInitialLoading}
      pageHeader={{
        subtitle: <MedicalCategoryName categoryName={categoryName} />,
        spacing: {
          top: 'm',
          bottom: 's',
        },
      }}
      pageFooter={null}
    >
      <>
        <MedicalCategoryProgress progressText={subscriberImqModule.categoriesProgressText} />
        <DynamicForm formDelegate={dynamicFormDelegate} showFooter={false} />
        <NavigationActionFooter
          allowSubmit={!isActionLoading && isFormValid}
          isLoading={isActionLoading}
          back={{
            text: 'Back To List',
            handler: returnBack,
          }}
          saveAndReturn={{
            text: 'Save & Return to List',
            handler: saveAndReturnToList,
          }}
          saveAndContinue={
            nextCategoryName
              ? {
                  text: 'Save & Go to Next Form',
                  handler: saveAndGoToNextForm,
                }
              : undefined
          }
        />
      </>
    </EmployeeFlowLayout>
  );
});

export default PageContent;
